import { makeStyles } from 'tss-react/mui';

import { alpha } from '@mui/material/styles';

export default makeStyles()((theme, _params, classes) => ({
    selected: {
        backgroundColor: alpha(theme.palette.primary.main, 0.15)
    },
    selectable: {
        cursor: 'pointer',
        [`&:not(.${classes.selected}):hover`]: {
            backgroundColor: alpha(theme.palette.primary.main, 0.05)
        }
    }
}));
